import { BACKEND_DATE_FORMAT } from 'config/Vars'
import moment from 'moment'

import { parseDateString } from 'modules/contracts/lib/utils'

export const getFirstPaymentDate = (effectiveDate: string | undefined): string => {
  const parsedEffectiveDate = effectiveDate ? parseDateString(effectiveDate) : null
  const normalizedEffectiveDate = parsedEffectiveDate?.isValid() ? parsedEffectiveDate : moment()
  const isFirstDayOfMonth = normalizedEffectiveDate.date() === 1

  const targetDate = isFirstDayOfMonth
    ? normalizedEffectiveDate.clone()
    : normalizedEffectiveDate.clone().add(1, 'month')

  return targetDate.startOf('month').format(BACKEND_DATE_FORMAT)
}
